import script from "./GetYingBiPage.vue?vue&type=script&setup=true&lang=js"
export * from "./GetYingBiPage.vue?vue&type=script&setup=true&lang=js"

import "./GetYingBiPage.vue?vue&type=style&index=0&id=6a937cfb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a937cfb"]])

export default __exports__